"use strict";
exports.__esModule = true;
var Timer = /** @class */ (function () {
    function Timer(callback, delay) {
        this.timerId = null;
        this.start = delay;
        this.remaining = delay;
        this.callback = callback;
    }
    Timer.prototype.clear = function () {
        clearTimeout(this.timerId);
    };
    Timer.prototype.pause = function () {
        this.clear();
        this.remaining -= Date.now() - this.start;
    };
    Timer.prototype.resume = function () {
        this.start = Date.now();
        this.clear();
        this.timerId = setTimeout(this.callback, this.remaining);
    };
    return Timer;
}());
exports["default"] = Timer;
